import OverviewStatsTable from './overviewStatsTable';

export default OverviewStatsTable;